import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Loader2, Calendar, Sparkles } from 'lucide-react';

export function ForecastConfigCard({
  historyDays, setHistoryDays,
  forecastDays, setForecastDays,
  onRun, loading,
}) {
  return (
    <Card data-testid="forecast-config-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Calendar className="h-4 w-4" /> Forecast Configuration
        </CardTitle>
        <CardDescription>
          Configure analysis parameters and generate demand predictions
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col sm:flex-row gap-4 items-end">
          <div className="space-y-2 flex-1 sm:max-w-[200px]">
            <Label htmlFor="history-days">History to Analyze (days)</Label>
            <Input
              id="history-days"
              type="number"
              value={historyDays}
              onChange={(e) => setHistoryDays(parseInt(e.target.value) || 30)}
              min={7}
              max={365}
              data-testid="history-days-input"
            />
          </div>
          <div className="space-y-2 flex-1 sm:max-w-[200px]">
            <Label htmlFor="forecast-days">Forecast Period (days)</Label>
            <Input
              id="forecast-days"
              type="number"
              value={forecastDays}
              onChange={(e) => setForecastDays(parseInt(e.target.value) || 30)}
              min={7}
              max={90}
              data-testid="forecast-days-input"
            />
          </div>
          <Button
            onClick={onRun}
            disabled={loading}
            className="gap-2 min-w-[160px]"
            data-testid="run-forecast-btn"
          >
            {loading
              ? <><Loader2 className="h-4 w-4 animate-spin" /> Analyzing...</>
              : <><Sparkles className="h-4 w-4" /> Generate Forecast</>
            }
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
